enum Peril {
	FLOOD = 'FL',
	EARTHQUAKE = 'EQ',
	LANDSLIDE = 'LS',
	NONE = '',
}

namespace Peril {
	export function getPerilName(peril: Peril): string {
		switch (peril) {
			case Peril.FLOOD:
				return 'Flood';
			case Peril.EARTHQUAKE:
				return 'Earthquake';
			case Peril.LANDSLIDE:
				return 'Landslide';
			case Peril.NONE:
			default:
				return String.empty();
		}
	}
}

export default Peril;